//
//
//
//
//
//

export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      options: {},
    };
  },
  computed: {
    totalNum() {
      return this.list.reduce((cur, prev) => {
        return cur + prev.value;
      }, 0);
    },
  },
  watch: {
    list() {
      this.renderChart();
    },
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      this.options = {
        title: {
          text: "会员总数",
          subtext: `${this.totalNum}人`,
          itemGap: 5,
          textStyle: {
            color: "#333",
            fontSize: 14,
          },
          subtextStyle: {
            color: "#333",
            fontSize: 14,
          },
          left: "center",
          top: "35%",
        },
        tooltip: {},
        color: [
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#FFE293",
              },
              {
                offset: 1,
                color: "#FFC193",
              },
            ],
            global: false,
          },
          "#93C6FF",
          "#FFD693",
          "#F8E2BD",
          "#F8BDD6",
        ],
        series: [
          {
            type: "pie",
            radius: ["45%", "75%"],
            center: ["50%", "50%"],
            roseType: "radius",
            label: {
              color: "#666666",
            },
            labelLine: {
              length: 0,
              length2: 0,
            },
            itemStyle: {
              borderRadius: 8,
            },
            data: this.list,
          },
        ],
      };
    },
  },
};
